module.exports = __webpack_public_path__ + "media/images/invite-friend/invite-2-8fd41268e4bd751b65a93c37b9d7081b.png";